module.exports = __webpack_public_path__ + "img/6_64.19ed85ea.png";